import api from '@functions/api'

import type { EntityOptions } from '@redux/modules/types'

const searchEndpoint = (string: string, requestOptions: EntityOptions, requestUrl: string) => {
  if (!requestUrl) return { success: false as const, errors: ['requestUrl is required'] }

  const mergedOptions = {
    string,
    ...requestOptions,
  }

  return api(requestUrl, mergedOptions)
    .then(({ data }: { data: object[] }) => ({ success: true as const, data }))
    .catch(errors => ({ success: false as const, errors: errors as string[] }))
}

export default searchEndpoint
